<div class="location-input" [class.compacted]="compacted">
  <div class="location-input-wrapper">
    <input
      #input
      [readOnly]="!editable"
      class="p-autocomplete-input ush-location-selector-input"
      *ngIf="hasInput"
      #places_autocomplete
      [placeholder]="placeholderSig()"
      [(ngModel)]="value"
      (focus)="handleFocus($event)"
    />
    @if (editable) {
      @if (showMarker) {
        <fa-icon [icon]="locationIcon" class="input-icon marker-icon ush-location-selector-icon"></fa-icon>
      } @else {
        <fa-icon [icon]="searchIcon" class="input-icon search-icon ush-location-selector-icon"></fa-icon>
      }
    }
  </div>

  <button
    inputId="input-location"
    class="fit-width ush-near-me-button"
    pButton
    *ngIf="hasNearMe && editable"
    (click)="setNearMe()"
    [style.marginLeft]="hasInput ? 'var(--component-in-cinemas-near-me-margin-left, 5px)' : ''"
    type="button"
  >
    <span>{{ nearMeLabel }}</span>
    <fa-icon [icon]="houseIcon" class="house-icon" [attr.aria-label]="nearMeLabel" />
  </button>
</div>
